import type {
  CommentOrdering,
  NarrativeLayout,
  NarrativeRefreshContext,
  NarrativeRefreshType,
  WorkspaceVariant,
} from './types';

export abstract class CrfVersion {
  abstract readonly code: string;
  abstract get workspaceVariant(): WorkspaceVariant;
  abstract get narrativeLayout(): NarrativeLayout;
  abstract get commentOrdering(): CommentOrdering;
  abstract get viewCommentsLabel(): string;

  narrativeRefreshType(ctx: NarrativeRefreshContext): NarrativeRefreshType {
    if (this.narrativeLayout === 'multi-narrative') return 'multi';
    if (ctx.isLinkedMainNarrative) return 'main';
    if (ctx.isLinkedExtraNarrative) return 'extra';
    return '';
  }
}
